import { Suspense, lazy } from 'react';
import { Loading } from 'jbc-front/components/presenters/ui/Loading';
import { useQuery, gql } from '@apollo/client';
import { RightExpansionContainerProvider } from 'components/feature/RightExpansionContainer';

// @ts-ignore
import { AsyncTask } from 'components/AsyncTask';
// @ts-ignore
import { SessionProvider } from 'components/SessionProvider';

const AncientAdminRoutes = lazy(() => import(/* webpackChunkName: "admin2023" */ './AdminRoutesAncient'));
const Routes2024 = lazy(() => import(/* webpackChunkName: "admin2024" */ './AdminRoutes2024'));
const Routes2025 = lazy(() => import(/* webpackChunkName: "admin2025" */ '@jbc-year-end-adj/2025/routes/AdminRoutes'));
const Routes2026 = lazy(() => import(/* webpackChunkName: "admin2026" */ '@jbc-year-end-adj/2026/routes/AdminRoutes'));

export const Routes = () => {
  const year = Number(window.location.pathname.split('/')[1]);

  if (!year) {
    // default yearをfetchしてhistoryにpushする
    return <NoYearRoute />;
  } else {
    switch (year) {
      case 2026:
        return (
          <Suspense fallback={<Loading />}>
            <Routes2026 />
          </Suspense>
        );
      case 2025:
        return (
          <Suspense fallback={<Loading />}>
            <Routes2025 />
          </Suspense>
        );
      case 2024:
        // 全てのページを置き換えたらSessionProvider, AsyncTask, RightExpansionContainerProviderは削除
        return (
          <SessionProvider>
            <AsyncTask>
              <RightExpansionContainerProvider>
                <Suspense fallback={<Loading />}>
                  <Routes2024 />
                </Suspense>
              </RightExpansionContainerProvider>
            </AsyncTask>
          </SessionProvider>
        );
      default:
        return (
          <SessionProvider>
            <AsyncTask>
              <RightExpansionContainerProvider>
                <Suspense fallback={<Loading />}>
                  <AncientAdminRoutes />
                </Suspense>
              </RightExpansionContainerProvider>
            </AsyncTask>
          </SessionProvider>
        );
    }
  }
};

interface FetchDefaultYearQueryResult {
  defaultYear: number;
}

const FETCH_DEFAULT_YEAR = gql`
  query fetchDefaultYear {
    defaultYear
  }
`;

const NoYearRoute = () => {
  const { loading, data, error } = useQuery<FetchDefaultYearQueryResult>(FETCH_DEFAULT_YEAR);

  if (loading) {
    return <Loading />;
  } else if (data) {
    const { pathname, search } = window.location;

    window.location.href = `/${data.defaultYear}${pathname}${search}`;
    return null;
  } else if (error) {
    throw error;
  }

  return null;
};
